import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';
import { makeStyles } from '@lifeomic/chroma-react/styles';
import { TableModule } from '@lifeomic/chroma-react/components/TableModule';

const useStyles = makeStyles(() => ({
  cell: {
    whiteSpace: 'break-spaces',
  },
}));

const messages = defineMessages({
  name: {
    id: 'patientViewer.consentList.headers.name',
    defaultMessage: 'Name',
  },
  status: {
    id: 'patientViewer.consentList.headers.status',
    defaultMessage: 'Status',
  },
  version: {
    id: 'patientViewer.consentList.headers.version',
    defaultMessage: 'Version',
  },
  date: {
    id: 'patientViewer.consentList.headers.date',
    defaultMessage: 'Date',
  },
  acceptedHeader: {
    id: 'patientViewer.consentList.headers.acceptedHeader',
    defaultMessage: 'Accepted?',
  },
  acceptedValue: {
    id: 'patientViewer.consentList.headers.acceptedHeader',
    defaultMessage: 'Accepted',
  },
});

const ConsentList = ({ data, onConsentSelect, isFetching }) => {
  const { formatMessage } = useIntl();
  const classes = useStyles({});

  const sorted = [...data];
  sorted.sort(
    (consent1 = {}, consent2 = {}) => consent2.sortValue - consent1.sortValue,
  );

  const columns = [
    {
      header: {
        label: formatMessage(messages.name),
      },
      cell: {
        className: classes.cell,
        content: consent => consent?.name,
      },
    },
    {
      header: {
        label: formatMessage(messages.status),
      },
      cell: {
        content: consent => consent?.status,
      },
    },
    {
      header: {
        label: formatMessage(messages.acceptedHeader),
      },
      cell: {
        content: consent => {
          const isAccepted = consent?.originalStatus === 'active';
          return isAccepted ? formatMessage(messages.acceptedValue) : '';
        },
      },
    },
    {
      header: {
        label: formatMessage(messages.version),
      },
      cell: {
        content: consent => consent?.version,
      },
    },
    {
      header: {
        label: formatMessage(messages.date),
      },
      cell: {
        className: classes.cell,
        content: consent => consent?.date,
      },
    },
  ];

  return (
    <TableModule
      config={columns}
      data={sorted}
      isLoading={isFetching}
      onRowClick={onConsentSelect}
    />
  );
};

ConsentList.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  onConsentSelect: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
};

export default ConsentList;
